function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { Fragment, useState, useMemo, useRef, useEffect } from 'react';
import { string, bool } from 'prop-types';
import classnames from 'classnames';
import { SHOW_MORE } from "../../../utils/default-strings";
import { testidFactory } from "../../../utils/testid";
import { getParagraphsFromStrings } from "../../../utils/get-paragraphs-from-strings";
import { Paragraph } from "../Paragraph";
import { HTML } from "../../general-widgets/HTML";
import { MULTI_PARAGRAPH_MAX_HEIGHT } from "./constants";
var TEST_ID_PREFIX = 'multiparagraph';
var testid = testidFactory(TEST_ID_PREFIX);
export var Component = function Component(_ref) {
  var content = _ref.content,
      showMoreLabel = _ref.showMoreLabel,
      isShowingAll = _ref.isShowingAll,
      isHtml = _ref.isHtml;

  var _useState = useState(isShowingAll),
      _useState2 = _slicedToArray(_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  var paragraphs = useMemo(function () {
    return getParagraphsFromStrings(content);
  }, [content]);
  var contentRef = useRef();
  useEffect(function () {
    if (contentRef.current.scrollHeight < MULTI_PARAGRAPH_MAX_HEIGHT) {
      setIsOpen(true);
    } else {
      setIsOpen(isShowingAll);
    }
  }, [content]);
  return React.createElement(Fragment, null, React.createElement("div", {
    className: classnames('multi-paragraph', {
      open: isOpen
    }),
    "data-testid": testid(),
    ref: contentRef
  }, isHtml ? React.createElement(HTML, {
    "data-testid": testid('html-paragraph'),
    htmlString: content
  }) : paragraphs.map(function (paragraph, key) {
    return React.createElement(Paragraph, {
      "data-testid": testid("paragraph-".concat(key)),
      key: key
    }, paragraph);
  })), !isOpen && React.createElement("div", {
    className: "multi-paragraph-read-more",
    "data-testid": testid('button-read-more'),
    onClick: function onClick() {
      return setIsOpen(true);
    },
    role: "button"
  }, React.createElement("span", null, showMoreLabel)));
};
Component.displayName = 'MultiParagraph';
Component.defaultProps = {
  showMoreLabel: SHOW_MORE,
  isShowingAll: false,
  isHtml: false
};
Component.propTypes = process.env.NODE_ENV !== "production" ? {
  content: string.isRequired,
  isHtml: bool,
  isShowingAll: bool,
  showMoreLabel: string
} : {};